import { FormikProps, getIn } from "formik"
import { FormikTextField, FormikMultiFileUpload } from "./CustomFormikFormFields"
import clsx from "clsx"
import { IWebFileAttachment } from "../../modules/core/applications"
import { FileUploader, FileUploaderResponse } from "./FileUploader"
import { cloneDeep } from "lodash"
import { AttachmentCard } from "../../modules/core/attachments/AttachmentCard"
import { useAuth } from "../../modules/auth"

export const FormikNotesArea =({ label, attachLabel, required } : {label?: string, required?: boolean, attachLabel?: string}) => {
  return(
  <>
  <div className="row mb-2">
    <FormikTextField size="12" label={label ? label : "Note"} name="note" rows={2} required={required} />
  </div>
  <div className="row mb-2">
    <label className='col-form-label fw-bold fs-7 mb-n4'>{attachLabel ? attachLabel : "Note Attachment/s"}</label>
    <FormikMultiFileUpload size="12" label="Note Attachment/s" name="noteAttachments" />
  </div>
  </>
  )
}


type CompProps = {
  formik : FormikProps<any & { note: string, noteAttachments: Array<IWebFileAttachment>}>
  required?: boolean
  label?: string
  attachLabel?: string
}

export const FormikNotesComponent = ({formik, label, attachLabel, required} : CompProps) => {
    
  const { currentUser }  = useAuth();
  const noteAttachments = getIn(formik.values, 'noteAttachments');

  return (
  <>
    <div className='fv-row mb-2'>
      <label className='col-form-label fw-bold fs-7'>
        <span className={clsx({'required': required})}>{label ? label : "Note"}</span>                    
      </label>                
      <textarea
        placeholder={`Enter ${label ? label : "Note"}`}
        {...formik.getFieldProps('note')}                        
        name='note'                                            
        className='form-control form-control-solid'
        rows={3}                                        
      ></textarea>
      {(formik.errors?.note) && (
      <div className='fv-plugins-message-container'>                    
        <div className='fv-help-block'>{`${formik.errors.note}`}</div>
      </div>
      )}                                                        
    </div>
    <div className='fv-row mb-2'>
      <label className='col-form-label fw-bold fs-7 mb-n2'>{attachLabel ? attachLabel : "Note Attachment/s"}</label>
      <div className="row">
        <div className="col-md-6">
          <FileUploader 
            mainTitle="Note Attachment/s"
            subTitle="Click or drop here to upload files."
            allowMultiple={false}
            acceptFiles={(currentUser && currentUser?.isSetsco) ? "UserFileFormats" : "ApplicantFileFormats"}
            onFileUploaded={ (dat: FileUploaderResponse) => {
              let _files = getIn(formik.values, 'noteAttachments');
              if (! _files) _files = [];
              _files.push(dat);                        
              formik.setFieldValue("noteAttachments", _files, false);                            
              setTimeout(() => formik.validateField("noteAttachments"), 100)
            }}                        
            onClearFile={ () => {
              formik.setFieldValue("noteAttachments", [], false);                            
              setTimeout(() => formik.validateField("noteAttachments"), 100)
            }}                        
          />
        </div>
      </div>
      <div className="row">
      { (noteAttachments && noteAttachments.length > 0) &&
        noteAttachments.map( (o: IWebFileAttachment, idx: number) => (
        <div className="col-6" key={`noteattach${idx}`} >
          <AttachmentCard             
            idx={idx} 
            fileId={o.id} 
            fileName={o.name}
            onRemove={(e: any) => {
              e.stopPropagation();
              const elem = e.target.closest('.attachment-card');                                    
              if (elem) {
                const {idx} = elem.dataset;
                
                let _files = cloneDeep(noteAttachments);                                                
                _files.splice(idx, 1);                                        
                formik.setFieldValue("noteAttachments", _files);                                                                    
                setTimeout(() => formik.validateField("noteAttachments"), 100)
              }
            }}
          />                   
        </div>                                 
        ))                    
        }            
      </div>
      {(formik.errors?.noteAttachments) && (
      <div className='fv-plugins-message-container'>                    
        <div className='fv-help-block'>{`${formik.errors.noteAttachments}`}</div>
      </div>
      )}
  </div>  
  </>
  )
}
 